import { render, staticRenderFns } from "./equityManagement.vue?vue&type=template&id=1665d964&scoped=true&"
import script from "./equityManagement.vue?vue&type=script&lang=js&"
export * from "./equityManagement.vue?vue&type=script&lang=js&"
import style0 from "./equityManagement.vue?vue&type=style&index=0&id=1665d964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665d964",
  null
  
)

export default component.exports